import styled from 'styled-components';

export const ContactContent = styled.div`
  border-radius: 16px;
  background: linear-gradient(135deg, #fffbeb 0%, #fff7ed 100%);
  border: 1px solid #fef3c6;
  padding: 25px;
`;
export const ContactTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #212529;
`;
export const TitleIcon = styled.img``;
export const ContactFildes = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;
export const ContactInputBox = styled.div`
  background: #ffffffb2;
  border: 1px solid #ffffff80;
  border-radius: 14px;
  flex: 1;
  padding: 6px 16px;
`;
export const InputLabel = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  gap: 8px;
  color: #6c757d;
`;
export const InputContent = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #212529;
  margin-top: 6px;
`;
